import { ModelAbstract } from 'Models';
import apiData from 'Storage/apiData';
import fixFloat from 'common/helpers/fixFloat';

import CommUnityCategoryModel from './CommUnityCategoryModel';

class CommUnityCatalogModel extends ModelAbstract {
  constructor(higherOrderInstance) {
    super(higherOrderInstance);
    this._categories = [];
  }

  get categories() {
    return this._categories;
  }

  get grandTotal() {
    return this._categories.reduce((total, category) => fixFloat(total + category.total), 0);
  }

  get upfrontGrandTotal() {
    return this._categories.reduce((total, category) => fixFloat(total + category.upfrontTotal), 0);
  }

  get recurringGrandTotal() {
    return this._categories.reduce((total, category) => fixFloat(total + category.recurringTotal), 0);
  }

  initLineItemsCatalogs() {
    apiData.categories.forEach(category => {
      const commUnityCategory = new CommUnityCategoryModel(this).setProps(category);
      this._categories.push(commUnityCategory);
    });

    return this;
  }

  get _hasError() {
    return this._categories.some(category => category.hasError);
  }

  get hasError() {
    return this._getCachedValueOnExport('_hasError');
  }
}

export default CommUnityCatalogModel;
